<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="mb-6 flex min-h-96 flex-col-reverse gap-4 lg:flex-row lg:gap-0">
    <div class="min-w-xl flex flex-1 items-center lg:mr-16">
      <img
        class="mx-auto aspect-[16/10] w-full max-w-lg shrink -rotate-3 rounded-[2rem] object-cover drop-shadow-lg"
        :src="`${S3_ASSETS_URL}/careers/hero-02-02.jpg`"
      >
    </div>

    <div
      class="flex min-w-[40%] flex-1 flex-col justify-between gap-6 pb-5 pt-5"
    >
      <div class="text-3xl font-normal">
        {{ t("careers.section.why_join_us.header") }}
      </div>

      <div class="text-base font-normal lg:max-w-lg">
        <i18n-t
          keypath="careers.section.why_join_us.description.first_paragraph.base"
          tag="div"
          class="text-base font-normal"
        >
          <template #placeholder>
            <strong class="font-normal md:font-bold">
              {{
                t(
                  "careers.section.why_join_us.description.first_paragraph.placeholder"
                )
              }}
            </strong>
          </template>
        </i18n-t>
      </div>

      <div class="text-base font-normal lg:max-w-lg">
        <i18n-t
          keypath="careers.section.why_join_us.description.second_paragraph.base"
          tag="div"
          class="text-base font-normal"
        >
          <template #placeholder>
            <strong class="font-normal md:font-bold">
              {{
                t(
                  "careers.section.why_join_us.description.second_paragraph.placeholder"
                )
              }}
            </strong>
          </template>
        </i18n-t>
      </div>

      <div class="flex flex-row items-center text-base font-normal">
        <UiIcon
          name="tick-solid"
          class="mr-2 text-orange-500 transition-transform duration-200 group-hover:translate-x-1"
        />

        {{ t("careers.section.why_join_us.cards.0") }}
      </div>

      <div class="flex flex-row items-center text-base font-normal">
        <UiIcon
          name="tick-solid"
          class="mr-2 text-orange-500 transition-transform duration-200 group-hover:translate-x-1"
        />

        {{ t("careers.section.why_join_us.cards.1") }}
      </div>

      <div class="flex flex-row items-center text-base font-normal">
        <UiIcon
          name="tick-solid"
          class="mr-2 text-orange-500 transition-transform duration-200 group-hover:translate-x-1"
        />

        {{ t("careers.section.why_join_us.cards.2") }}
      </div>

      <UiButton
        class="group w-52 w-full md:w-fit"
        as-child
      >
        <a
          href="/careers-listing"
          rel="nofollow noopener"
        >
          {{ t("careers.section.why_join_us.action") }}

          <UiIcon
            name="arrow-forward-rounded"
            class="transition-transform duration-200 group-hover:translate-x-1"
          />
        </a>
      </UiButton>
    </div>
  </div>
</template>
